import { FC, useEffect, useState } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { useApiGet } from '@/api/apiRequests';
import { getProgress } from '@/api/services/File';
import { AxiosError } from 'axios';

interface ProcessingStatusProps {
  fileId: string;
}

const ProcessingStatus: FC<ProcessingStatusProps> = ({ fileId }) => {
  const [processingProgress, setProcessingProgress] = useState(1);
  const [isProcessingComplete, setIsProcessingComplete] = useState(false);
  const [loadedPages, setLoadedPages] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { data: progressData, refetch: refetchProgress } = useApiGet<any, AxiosError>(
    ['pagesProgress', fileId],
    async () => await getProgress(fileId)
  );

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    const checkProcessingStatus = async () => {
      if (!progressData) return false;

      await refetchProgress();

      if (progressData) {
        const successfulPages = progressData.finished || 0;
        const totalPages = progressData.total || 0;
        const allPagesProcessed = successfulPages === totalPages;

        setLoadedPages(successfulPages);
        setTotalPages(totalPages);
        setProcessingProgress(Math.round((successfulPages / totalPages) * 100));

        setIsProcessingComplete(allPagesProcessed);

        return allPagesProcessed;
      }
      return false;
    };

    const startInterval = () => {
      checkProcessingStatus();

      intervalId = setInterval(async () => {
        const allProcessed = await checkProcessingStatus();
        if (allProcessed) {
          clearInterval(intervalId!);
        }
      }, 15000);
    };

    if (progressData) {
      startInterval();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [progressData, refetchProgress]);

  if (isProcessingComplete) return null;

  return (
    <div className={`pageProgress items-center gap-4 w-full p-4 hidden ${!isProcessingComplete ? 'flex' : ''}`}>
      <p className={'mb-0 inline-block flex-1'}>
        Zpracované stránky: <strong>{loadedPages}</strong> z <strong>{totalPages}</strong>
      </p>
      <ProgressBar
        className={`flex-1 opacity-80 ${isProcessingComplete ? 'isFull' : ''}`}
        style={{ height: '1.35rem', width: '100%' }}
        value={processingProgress}
      />
    </div>
  );
};

export default ProcessingStatus;
